export default __webpack_public_path__ + "static/media/Notes.7b817438.svg";